"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLiveVideo = exports.isYoutubeVideo = exports.isFacebookVideo = exports.isVideoOriginallyLive = exports.isVideoFromComputer = exports.isExternalVideoSource = exports.isExternalVideo = exports.isDownloadAllowed = void 0;
var video_sources_1 = require("@wix/wix-vod-constants/dist/common/video-sources");
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
var lodash_1 = require("lodash");
var isDownloadAllowed = function (video) { return video.allowDownload; };
exports.isDownloadAllowed = isDownloadAllowed;
var isExternalVideo = function (video) {
    return Boolean(video.mediaExternUrl);
};
exports.isExternalVideo = isExternalVideo;
var isExternalVideoSource = function (videoSource) {
    return video_sources_1.EXTERNAL_VIDEO_SOURCES.includes(videoSource);
};
exports.isExternalVideoSource = isExternalVideoSource;
var isVideoFromComputer = function (_a) {
    var videoSource = _a.videoSource;
    return videoSource === video_sources_1.VIDEO_SOURCES.COMPUTER;
};
exports.isVideoFromComputer = isVideoFromComputer;
var isVideoOriginallyLive = function (_a) {
    var videoSource = _a.videoSource;
    return videoSource === video_sources_1.VIDEO_SOURCES.LIVE;
};
exports.isVideoOriginallyLive = isVideoOriginallyLive;
var isFacebookVideo = function (_a) {
    var videoSource = _a.videoSource;
    return videoSource === video_sources_1.VIDEO_SOURCES.FACEBOOK;
};
exports.isFacebookVideo = isFacebookVideo;
var isYoutubeVideo = function (_a) {
    var videoSource = _a.videoSource;
    return videoSource === video_sources_1.VIDEO_SOURCES.YOUTUBE;
};
exports.isYoutubeVideo = isYoutubeVideo;
var isLiveVideo = function (_a) {
    var _b = _a === void 0 ? {} : _a, itemType = _b.itemType;
    return (0, lodash_1.includes)([item_type_1.ItemType.ItemLive, item_type_1.ItemType.ItemScheduled, item_type_1.ItemType.ItemLiveFinalize], itemType);
}; // TODO check if works
exports.isLiveVideo = isLiveVideo;
//# sourceMappingURL=video-origin.js.map